/** Shared landing imagery (main + designers pages). */

export type LandingExampleMedia =
  | { kind: 'image'; src: string }
  | { kind: 'video'; src: string; poster?: string }

export const LANDING_HERO_VIDEO = '/landing/L-H-01.mp4'

/** Indexed library — hero thumbnails, features, legacy index lookups on /designers. */
export const LANDING_LIB_IMAGES = [
  '/landing/L-H-02.jpg',
  '/landing/L-H-02.jpg',
  '/landing/L-H-03.png',
  '/landing/L-H-04.jfif',
  '/landing/L-H-05.jpg',
  '/landing/L-FE-01.jpg',
  '/landing/L-FE-02.jpg',
  '/landing/L-FE-03.svg',
  '/landing/L-FE-04.png',
  '/landing/L-EX-03.png',
  '/landing/L-EX-05.png',
  '/landing/L-EX-03.png',
  '/landing/L-EX-05.png',
  '/landing/L-EX-05.png',
  '/landing/L-EX-06.png',
] as const

export const LANDING_EXAMPLE_COUNT = 6

export const LANDING_EXAMPLES: readonly LandingExampleMedia[] = [
  { kind: 'video', src: '/landing/L-EX-01v.mp4' },
  { kind: 'video', src: '/landing/L-EX-02v.mp4' },
  { kind: 'image', src: '/landing/L-EX-03.png' },
  { kind: 'video', src: '/landing/L-EX-04.mp4' },
  { kind: 'image', src: '/landing/L-EX-05.png' },
  { kind: 'image', src: '/landing/L-EX-06.png' },
]

/** Hero mockup on /designers — product, moodboard, infographic. */
export const DESIGNERS_HERO_PREVIEW = {
  large: [2, 1],
  small: [6, 7, 8],
} as const
